import {useAtomValue} from 'jotai';
import {memo, useEffect, useState} from 'react';
import {MarkersLayerProps, SchoolData} from '@/map/@types';
import {useNearbySchool} from '@/map/api';
import {nearbyInfoAtom} from '@/map/atom';
import {SchoolMarker} from '@/map/components/Markers';
import {MARKER_COUNT_LIMIT, SCHOOL_TYPES} from '@/map/constants';
import {AreaAnalyticsFilter} from '@/map/enums';
import {convertToCoordFromPointCoords} from '@/map/utils';

const getList = (data?: SchoolData[]) => {
  const draft: SchoolData[] = [];

  if (!data) {
    return draft;
  }

  data.forEach((i) => {
    const index = draft.findIndex(
      (j) => i.name === j.name && i.studentsCount === j.studentsCount
    );

    if (index === -1) {
      const coords = i?.location?.coordinates;
      const point = convertToCoordFromPointCoords(coords);
      const item = {...i};

      if (point) {
        item.position = point;
      }

      draft.push(item);
    }
  });

  return draft;
};

interface IProps extends MarkersLayerProps {
  type: AreaAnalyticsFilter;
}

export const Layer = memo(({map, bounds, type}: IProps) => {
  const {selected} = useAtomValue(nearbyInfoAtom);
  const isActive = selected.includes(type);
  const [list, setList] = useState<SchoolData[]>([]);

  const {data} = useNearbySchool(
    isActive && bounds
      ? {
          types: (SCHOOL_TYPES as any)[type],
          ...bounds,
        }
      : undefined
  );

  useEffect(() => {
    if (data?.length) {
      setList((prev) => {
        return getList([
          ...prev.filter(
            (i) => i.position && map.getBounds().hasPoint(i.position)
          ),
          ...data.slice(0, MARKER_COUNT_LIMIT),
        ]);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  if (!isActive || !list?.length) {
    return null;
  }

  return (
    <>
      {list.map(
        (i, idx) =>
          !!i.position && (
            <SchoolMarker
              // key에 idx 값을 넣어서 중복 데이터로 인한 좀비마커 생성 방지
              key={idx + i.name + i.position.toString()}
              map={map}
              position={i.position}
              type={type}
              item={i}
            />
          )
      )}
    </>
  );
});
